var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarkerOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.259,
    height: 38.914,
    viewBox: "0 0 31.259 38.914",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18719",
    "data-name": "Group 18719",
    transform: "translate(-7.033 -2.303)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M19.13,2A15.13,15.13,0,0,0,4,16.979c0,10.363,13.333,21.9,13.9,22.391a1.891,1.891,0,0,0,2.459,0c.662-.492,13.9-12.028,13.9-22.392A15.13,15.13,0,0,0,19.13,2Zm0,3.631Z",
    transform: "translate(3.533 0.803)",
    fill: "rgba(255,255,255,0)",
    stroke: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M18.288,21.794a6.006,6.006,0,1,1,6.006-6.006A6.006,6.006,0,0,1,18.288,21.794Z",
    transform: "translate(4.375 0.707)",
    fill: "rgba(255,255,255,0)",
    stroke: "currentColor",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerOutline);
export default __webpack_public_path__ + "static/media/marker-outline.45ccf36ecbbef3b707a2032062cfafb2.svg";
export { ForwardRef as ReactComponent };